import * as types from '@/actions/types'
import utils from '@/utils'

const initialState = {
  items: [],
  categories: {},
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case types.SHOP_INJECT_PRODUCT:
      state = {
        ...state,
        items: utils.array.removeDuplicates(utils.array.mergeArrays(state.items, action.items), 'id'),
      }
      break
    case types.SHOP_INJECT_CATEGORIES:
      state = {
        ...state,
        categories: { ...state.categories, ...action.categories },
      }
      break
    default:
      return { ...state }
  }
  return { ...state }
}

export default reducer
